import { forwardRef, useCallback } from "react";
import { twMerge } from "tailwind-merge";

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, "onResize"> {
  onResize: (x: number, y: number) => void;
  direction: "horizontal" | "vertical";
  className?: string;
}

/**
 * Resize handle for the sidebar / drawer / etc.
 */
export const ResizeHandle = forwardRef<HTMLDivElement, Props>(
  ({ onResize, direction, className, ...props }, ref) => {
    const handleDrag = useCallback(() => {
      const onMouseMove = (event: MouseEvent) => {
        onResize?.(event.clientX, event.clientY);
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    }, []);

    return (
      <div
        {...props}
        className={twMerge(
          "z-50 select-none overflow-clip before:bg-transparent before:transition-colors before:delay-75 hover:before:bg-purple-600 active:before:bg-purple-600",
          direction === "horizontal" &&
            "absolute bottom-0 top-0 w-[7px] -translate-x-1/2 cursor-col-resize before:absolute before:bottom-0 before:left-[2px] before:top-0 before:w-[3px]",
          direction === "vertical" &&
            "absolute left-0 right-0 h-[7px] -translate-y-1/2 cursor-row-resize before:absolute before:left-0 before:right-0 before:top-[2px] before:h-[3px]",
          className,
        )}
        onMouseDown={handleDrag}
        ref={ref}
      />
    );
  },
);
